import { useContext } from 'react'
import { WorkoutOverrideModalContext } from 'components/Modals/Popups/WorkoutOverrideModal'

import ExerciseOverrideInput from 'components/Modals/Components/WorkoutOverrideModal/ExerciseOverrideInput'
import SetUnitsOverrideInput from 'components/Modals/Components/WorkoutOverrideModal/SetUnitsOverrideInput'
import WeightRecommendationOverrideInput from 'components/Modals/Components/WorkoutOverrideModal/WeightRecommendationOverrideInput'

export default function SlotOverrideListItem({
    programTableColumnTaperData,
    phaseVolumeData,
    phaseIndex,
    slotIndex
}) {

    const { GetWorkoutTemplateDisplayData } = useContext(WorkoutOverrideModalContext)

    const exerciseDisplayData = GetWorkoutTemplateDisplayData('one-off-exercise-swap', phaseIndex, slotIndex)
    const setUnitsDisplayData = GetWorkoutTemplateDisplayData('one-off-reps-override', phaseIndex, slotIndex)

    if (exerciseDisplayData.value === null) return null

    return (
        <div 
            className={`
                grid grid-cols-4
                ${exerciseDisplayData.overrideApplied ? 'bg-orange-100' : ''}
            `}
        >
            <ExerciseOverrideInput
                phaseIndex={phaseIndex} 
                slotIndex={slotIndex} 
                exercise={exerciseDisplayData.value} 
            />
            
            <SetUnitsOverrideInput
                phaseIndex={phaseIndex} 
                slotIndex={slotIndex} 
                exercise={exerciseDisplayData.value} 
                setUnitsDisplayData={setUnitsDisplayData}
            />

            <WeightRecommendationOverrideInput
                phaseVolumeData={phaseVolumeData}
                programTableColumnTaperData={programTableColumnTaperData}
                phaseIndex={phaseIndex} 
                slotIndex={slotIndex} 
                exercise={exerciseDisplayData.value}
                setUnits={setUnitsDisplayData.value}
            />
        </div>
    )

}